import { Button, Link, Typography } from '@mui/material';
import { Column, Row, Spacer } from '../components';
import { Svgs } from '../assets/svg';
import { domain } from '../api/apis';
import { useDeviceType } from '../hooks/useDeviceType';
import { logoGcSmall } from '../assets/png';
import * as Style from '../dashboard/main/style';

const ChooseAccountType = () => {
  const handleOrgSignUp = () => {
    window.location.replace(`https://ipm-auth.${domain}/oauth2/authorization/B2C_1_signup1`);
  };
  const handleOrgLogIn = () => {
    window.location.replace(`https://ipm-auth.${domain}`);
  };

  const { isMobile, isTablet } = useDeviceType();
  return (
    <Style.MainWrapper>
      <Style.MainLayout>
        <Style.MainSection>
          <Style.MainContentRight>
            <Column style={{ margin: isMobile || isTablet ? '20px' : '20px 100px' }}>
              <Row style={{ justifyContent: isMobile || isTablet ? 'flex-start' : 'flex-end' }}>
                <img
                  src={logoGcSmall}
                  alt={`GuidedChoice Logo`}
                  style={{ width: '200px', height: 'auto' }}
                />
              </Row>
              <Spacer height='sm' />
              <Row
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '150px',
                }}>
                <Svgs.ArtOrganization />
              </Row>
              <Spacer height='sm' />
              <Typography variant='h1' color='secondary' style={{ textAlign: 'center' }}>
                Welcome to the GuidedChoice partner portal!
              </Typography>
              <Spacer height='xs' />
              <Typography variant='h2' color='info.main' style={{ textAlign: 'center' }}>
                Log in with your partner portal credentials.
              </Typography>
              <Spacer height='lg' />
              <>
                <Row style={{ justifyContent: 'center' }}>
                  <Button
                    className='xl'
                    color='primary'
                    onClick={handleOrgLogIn}
                    style={{ maxWidth: 300 }}>
                    Log In
                  </Button>
                </Row>
                <Spacer height='xs' />
                <Row style={{ justifyContent: 'center' }}>
                  <Button
                    className='xl'
                    color='secondary'
                    variant='outlined'
                    onClick={handleOrgSignUp}
                    style={{ maxWidth: 300 }}>
                    Sign Up
                  </Button>
                </Row>
                <Spacer height='sm' />
                <Typography variant='h2' color='primary' style={{ textAlign: 'center' }}>
                  Not ready to sign up?{' '}
                  <Link href={`https://3nickels.com/partner-portal/`}>
                    Learn more about our solutions
                  </Link>
                </Typography>
              </>
              <Spacer height='xs' />
            </Column>
          </Style.MainContentRight>
        </Style.MainSection>
      </Style.MainLayout>
    </Style.MainWrapper>
  );
};

export default ChooseAccountType;
